import { useEffect, useMemo, useState, useRef } from 'react';
import { Container } from './styled';
import { useChat } from '../../../../../../contexts/chat';
import { Card } from './components/Card/index';

export function New(props) {

    const { isVisibility } = props;
    const {
        idChat,
        resetChat,
        newChats,
        onFilter,
        handleNewChats
    } = useChat();
    const [displayedPeople, setDisplayedPeople] = useState(50);
    const [selectedCustomer, setSelectedCustomer] = useState({
        isOpen: false,
        customerServicersID: []
    });
    const listRef = useRef(null);

    useEffect(() => {
        if (!isVisibility) return
        if (!newChats) return
        const isChatOpen = newChats?.some(item => item.client_phone === idChat)
        if (!isChatOpen) {
            resetChat();
        }
    }, [newChats]);

    useEffect(() => {
        handleNewChats()
    }, [])
    const handleScroll = () => {
        const element = listRef.current;
        if (element.scrollTop + element.clientHeight + 50 >= element.scrollHeight) {
            setDisplayedPeople(prevCount => prevCount + 50);
        }
    };
    useEffect(() => {
        const element = listRef.current;
        element.addEventListener('scroll', handleScroll);
        return () => element?.removeEventListener('scroll', handleScroll);
    }, []);
    const allIDS = newChats?.map((item) => item.id);
    const onSelectedCustomer = (id) => {
        setSelectedCustomer(prev => {
            const updatedCustomerServicersID = prev?.customerServicersID?.includes(id)
                ? prev.customerServicersID.filter(item => item !== id)
                : [...prev.customerServicersID, id];
            return {
                ...prev,
                customerServicersID: updatedCustomerServicersID
            };
        });
    };
    const handleSelectedAll = (e) => {
        if (e) {
            setSelectedCustomer({
                isOpen: true,
                customerServicersID: allIDS
            });
            return
        }
        setSelectedCustomer({
            isOpen: true,
            customerServicersID: []
        });
    };


    const visibleData = newChats.filter(
        (e) => {
            return onFilter(e, 0)
        }
    )?.slice(0, displayedPeople);
    const myStateElements = useMemo(() => visibleData
        ?.map((item) => (
            <Card
                key={item?.client_phone}
                data={item}
                active={idChat === item?.client_phone}
                onSelectedCustomer={onSelectedCustomer}
                selectedCustomer={selectedCustomer}
            />
        )
        ), [visibleData, selectedCustomer]);

    return (
        <Container ref={listRef} visibility={isVisibility ? 1 : 0}>
            {/* {newChats.length !== 0 && (
                <SelectMultipleCustomerService
                    isOpen={selectedCustomer.isOpen}
                    customersSelected={selectedCustomer.customerServicersID}
                    customerServicesAll={allIDS?.length}
                    onClose={() => {
                        setSelectedCustomer({
                            isOpen: false,
                            customerServicersID: []
                        })
                    }}
                    onOpen={() => {
                        setSelectedCustomer({
                            isOpen: true,
                            customerServicersID: []
                        })
                    }}
                    onSelectAll={(e) => {
                        handleSelectedAll(e)
                    }}
                    actions={{
                        initialize: true,
                        transfer: false,
                        finish: true
                    }}
                />
            )} */}
            {myStateElements}
        </Container>
    );
}